export const dashHome = {
  index: {
    boxes: {
      reservas: "Bookings",
      checkins: "Check-ins",
      ocupacion: "Occupancy",
      facturacion: "Revenue",
      ingresosTotal: "Total revenue",
      saldos: "Pending balances",
      solicitudes: "AI requests",
      facturas: "Pending invoices",
      acciones: "Pending actions",
      salen: "Leaving today",
      llegadas: "Upcoming arrivals",
      ingresosDesglose: "Revenue breakdown",
    },
    editToolbar: {
      done: "Done",
      addBox: "Add box",
      reset: "Reset",
      hint: "Drag to move · pull the corner to resize",
      allBoxesVisible: "All boxes are visible.",
      removeTitle: "Remove",
      showOnboarding: "Show the setup notice",
    },
  },
  arrivals: {
    viewAll: "View all arrivals",
  },
  todayLeaving: {
    title: "Guests checking out today",
    subtitle: "Check-outs scheduled for today.",
    empty: "No guests checking out today.",
    loading: "Loading today's check-outs…",
    balance: "Balance",
    balanceDueTitle: "Balance due: {amount} {currency}",
    paid: "Paid",
    paidTitle: "Booking paid",
    viewAll: "View all check-outs",
  },
  mobileNotice: {
    sheetAriaLabel: "Download the WACheckin app",
    closeAriaLabel: "Close",
    title: "Get the most out of WACheckin",
    desc: "The panel is designed for <b>desktop</b>. On mobile you get a summary; to manage <b>all the features</b> comfortably, open it on your computer or download our <b>app</b>.",
    appStorePrefix: "Download on the",
    googlePlayPrefix: "Get it on",
    continueOnMobile: "Keep viewing on mobile",
  },
};
